
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/about-zsl/our-people",
      function () {
        return require("private-next-pages/about-zsl/our-people.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/about-zsl/our-people"])
      });
    }
  